export default __webpack_public_path__ + "static/media/Zahl-5.429a4aad.png";